import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "children", "flush", "use"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Main body of the app. There should only be one per application.
 *
 * @category Layout
 */

export default function UIMain(_ref) {
  let {
      className,
      children,
      flush,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const classes = classNames('private-main', className, flush && 'private-main--flush', use === 'dark' && 'private-main--dark');
  return /*#__PURE__*/_jsx("main", Object.assign({
    className: classes
  }, rest, {
    children: children
  }));
}
UIMain.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  flush: PropTypes.bool,
  use: PropTypes.oneOf(['standard', 'dark'])
};
UIMain.displayName = 'UIMain';